<template lang="pug">
  section.hero.is-light
    .hero-head
      .container.has-text-centered
        h1.title ⛽Aplicación para Accesos 🚛
    .hero-body
      .container.has-text-centered
        h2.subtitle v 0.0.1
</template>

<script>
  export default {
    name: 'HeaderAccesos'
  }
</script>

<style lang="css">
  .hero.is-light {
    padding: 25px 0;
  }

  .hero-body {
    padding: 1rem 1.5rem;
  }
  
</style>





// WEBPACK FOOTER //
// src/components/accesos_Componentes/layout/HeaderAccesos.vue